import { getPresenterLayout } from '../../../../../shared/helpers/layout-manager/get-presenter-layout';
import { PositionHelpers } from '../hooks/useCommonLayoutStyles';

export const ARROW_PADDING = 44;
const ARROW_SIZE = 36;
const PRESENTER_PAGE_BUTTON_STYLES: React.CSSProperties = {
    top: '42px',
    width: ARROW_SIZE,
    height: ARROW_SIZE,
    zIndex: 3,
};

const oldGetStartButtonStyles: PositionHelpers['getStartButtonStyles'] = (areas) => {
    const firstInRow = areas[1];
    const x = firstInRow?.x ?? 0;

    return {
        ...PRESENTER_PAGE_BUTTON_STYLES,
        left: x ? Math.max(x - ARROW_PADDING, 10) : `calc(50% - ${ARROW_SIZE / 2}px)`,
    };
};
const oldGetEndButtonStyles: PositionHelpers['getEndButtonStyles'] = (areas, containerWidth: number) => {
    const lastInRow = areas[areas.length - 1];
    const x = lastInRow?.x ?? 0;
    const width = lastInRow?.width ?? 0;
    const position: {
        left?: number;
        right?: number;
    } = {};

    if (x + width + ARROW_PADDING + ARROW_SIZE < containerWidth) {
        position.left = x + width + ARROW_PADDING - ARROW_SIZE;
    } else {
        position.right = 10;
    }

    return {
        ...PRESENTER_PAGE_BUTTON_STYLES,
        ...position,
    };
};
const newGetStartButtonStyles: PositionHelpers['getStartButtonStyles'] = (areas) => {
    const firstInRow = areas[1];
    const x = firstInRow?.x ?? 0;
    const top = `calc(50% - ${ARROW_SIZE / 2}px)`;
    return {
        ...PRESENTER_PAGE_BUTTON_STYLES,
        left: x ? Math.max(x - ARROW_PADDING, 10) : `calc(50% - ${ARROW_SIZE / 2}px)`,
        top,
    };
};
const newGetEndButtonStyles: PositionHelpers['getEndButtonStyles'] = (areas, containerWidth: number) => {
    const lastInRow = areas[areas.length - 1];
    const x = lastInRow?.x ?? 0;
    const width = lastInRow?.width ?? 0;

    const position: {
        left?: number;
        right?: number;
    } = {};

    if (x + width + ARROW_PADDING + ARROW_SIZE < containerWidth) {
        position.left = x + width + ARROW_PADDING - ARROW_SIZE;
    } else {
        position.right = 10;
    }
    const top = `calc(50% - ${ARROW_SIZE / 2}px)`;
    return {
        ...PRESENTER_PAGE_BUTTON_STYLES,
        ...position,
        top,
    };
};

export const getStartButtonStyles: PositionHelpers['getStartButtonStyles'] = (areas, isNewGrid = false) => {
    return isNewGrid ? newGetStartButtonStyles(areas) : oldGetStartButtonStyles(areas);
};

export const getEndButtonStyles: PositionHelpers['getEndButtonStyles'] = (
    areas,
    containerWidth: number,
    isNewGrid = false
) => {
    return isNewGrid ? newGetEndButtonStyles(areas, containerWidth) : oldGetEndButtonStyles(areas, containerWidth);
};

type GetAreaParams = {
    shouldSwapSelfView?: boolean;
    isNewGrid?: boolean;
    isScreenSharingActive?: boolean;
    isMobile?: boolean;
};
export const getAreas = ({
    shouldSwapSelfView,
    isNewGrid,
    isMobile,
    isScreenSharingActive,
}: GetAreaParams): PositionHelpers['getAreas'] => {
    return (layoutSize, totalCount) =>
        getPresenterLayout({
            size: layoutSize,
            count: totalCount,
            shouldSwapSelfView,
            isNewGrid,
            isScreenSharingActive,
            isMobile,
        });
};
